import { render, staticRenderFns } from "./RegisteredIcookin.vue?vue&type=template&id=0a965e92&scoped=true"
import script from "./RegisteredIcookin.vue?vue&type=script&lang=js"
export * from "./RegisteredIcookin.vue?vue&type=script&lang=js"
import style0 from "./RegisteredIcookin.vue?vue&type=style&index=0&id=0a965e92&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a965e92",
  null
  
)

export default component.exports